import { Injectable } from '@angular/core';
import { EstadoSolicitud } from "src/app/core/models/enum/estado-solicitud.enum";
import { obtenerSolicitudTipoId,  SolicitudTiposEnum } from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import {GestorSolicitudesConsultas} from "src/app/core/services/gestor/consultas/gestor-solicitudes-consultas.service";

@Injectable({
  providedIn: 'root'
})
export class ValidacionRadicacionSolicitudService {

  constructor(
    private gestorSolicitudesConsultas: GestorSolicitudesConsultas
  ) {}

 public async existeSolicitudEnProceso(
    tipoIdentidadBeneficiario: string,
    numeroIdentidadBeneficiario: string,
    tipoIdentidadTitular: string,
    numeroIdentidadTitular: string,
    tipoSolicitud: SolicitudTiposEnum
  ): Promise<boolean> {

    const tipoSolicitudId = obtenerSolicitudTipoId(tipoSolicitud);

    const fechaDesde = new Date();
    fechaDesde.setMonth(fechaDesde.getMonth() - 2);
    fechaDesde.setHours(0, 0, 0, 0);

    const fechaHasta = new Date();
    fechaHasta.setHours(23, 59, 59, 999);

    const desde = fechaDesde.toISOString();
    const hasta = fechaHasta.toISOString();

    const portal = 2;

    const estados = [
      EstadoSolicitud.EN_PROCESO,
      EstadoSolicitud.DEVOLUCION,
      EstadoSolicitud.DEVOLUCION_SUBSANADA,
      EstadoSolicitud.APROBADO,
      EstadoSolicitud.APROBADO_PARCIAL,
      EstadoSolicitud.COMPLETADO_PARCIAL,
      EstadoSolicitud.EN_VALIDACION_INTERNA
    ];

    try {
      const resp = await this.gestorSolicitudesConsultas
        .validarSolicitudEnProceso({
          tipoSolicitudId,
          tipoIdentidadTitular,
          numeroIdentidadTitular,
          tipoIdentidadBeneficiario,
          numeroIdentidadBeneficiario,
          desde,
          hasta,
          portal,
          estados
    })
        .toPromise();

      return !!resp;

    } catch (error) {
      console.error('[existeSolicitudEnProceso] Error consultando API:',error);
      return false;
    }
  }


}